const actionTypes = { SET_ENHANCED_CONTENT: 'SET_ENHANCED_CONTENT' };

module.exports = actionTypes;
